import styled from 'styled-components';
export const Section = styled.section `
  padding: ${({ theme }) => theme.spacing.section} 0;
  background: ${({ $tone, theme }) => ($tone === 'soft' ? theme.colors.surface : theme.colors.white)};
`;
export const SectionHeader = styled.div `
  max-width: 680px;
  margin-bottom: ${({ theme }) => theme.spacing.xl};

  p {
    color: ${({ theme }) => theme.colors.muted};
    font-size: ${({ theme }) => theme.typography.sizes.lg};
  }
`;
export const Eyebrow = styled.p `
  margin: 0 0 ${({ theme }) => theme.spacing.sm};
  color: ${({ theme }) => theme.colors.blue600};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  font-weight: 800;
  text-transform: uppercase;
`;
export const Heading = styled.h1 `
  margin: 0;
  color: ${({ theme }) => theme.colors.navy900};
  font-size: ${({ theme }) => theme.typography.sizes.xxl};
  line-height: ${({ theme }) => theme.typography.lineHeights.heading};
`;
